import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "submit"];

  connect() {
    this._syncSubmit();
  }

  toggle() {
    this._syncSubmit();
  }

  _syncSubmit() {
    this.submitTarget.disabled = !this.checkboxTarget.checked;
  }
}
